import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { APPOINTMENT_VIEWS } from "@/api/queries/appointments";
import { AppointmentsPage } from "@/features/appointments/appointments-page";

export const Route = createFileRoute("/_authenticated/$store/appointments/")({
  validateSearch: z.object({ view: z.enum(APPOINTMENT_VIEWS).optional().catch(undefined) }),
  head: () => ({ meta: [{ title: "Appointments · Rogue AI" }] }),
  component: AppointmentsPage,
});
